












































import { Component, Vue, Prop } from "vue-property-decorator";
import * as signalR from "@microsoft/signalr";    
import { saveAs } from 'file-saver';
import axios from 'axios';
import { PROCESS_EXECUTION_MODE_ENUM, PROCESS_TYPE_ENUM } from "@/services/Enums";
import { General } from "@/services/General";
import { i18n } from "@/i18n/i18n-setup";
import { Process } from "@/entity/Process";

@Component({
    components: {
    }
})
export default class DownloadFileBackground extends Vue {
    @Prop({ type: String, required: true })
    downloadUrl;
    @Prop({ required: true})
    processType: PROCESS_TYPE_ENUM;
    @Prop({ type: String, required: true})
    processDescription;
    @Prop({ required: false })
    bodyParameter;
  
    ready: boolean = false;
    connection: any;
    idProcess: string = "";
    createdProcess: boolean = false;
    showDownloadFile: boolean = false;
    isProcessInError: boolean = false;
    process: Process = new Process();
    general: any = {};
    fileSessionId: string = "";

    async mounted() {
        this.reset();
        this.general = General;
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(General.GetApiUrl('/message'))
            .build();
            
        this.connection.start();
            
        //devo creare il processo
        await this.createProcess();

        //download del file e monitoring
        if(this.createdProcess) {
            await this.getFile();
        }
    }

    reset() {
        if (this.connection)
            this.connection.stop();
        this.ready = false;
        this.idProcess = "";
        this.createdProcess = false;
        this.showDownloadFile = false;
        this.isProcessInError = false;
        this.process = new Process();
        this.fileSessionId = "";
    }

    async createProcess() {
        try {
            let responseProcess = await axios({
                method: 'get',
                url: General.GetApiUrl('/api/Process/CreateProcess?processType=' + this.processType + '&processDescription=' + this.processDescription + "&executionMode=" + PROCESS_EXECUTION_MODE_ENUM.immediate),
                withCredentials: true
            });

            this.idProcess = responseProcess.data;
            this.createdProcess = true;
        }
        catch(error) {  
            this.reset();             
            General.HandleError(error, this);
        }
    }

    async getFile() {
        try {
            await axios({
                method: 'post',
                url: General.GetApiUrl(this.downloadUrl + '?idProcess=' + this.idProcess),
                data: this.bodyParameter,
                withCredentials: true
            }).then( () => {
                this.ready = true;
                this.monitoringProcess();
            });
        }
        catch(error) {                
            this.reset();
            this.isProcessInError = true;               
            this.ready = true;
            General.HandleError(error, this);
        }
    }

    monitoringProcess() {
        let app = this;

        this.connection.on("instantProcessStatus", data => {
            var dataParsed = JSON.parse(data);
            app.process = General.filterProcess(dataParsed).filter(x=>x.ProcessId==app.idProcess)[0];

            if(this.process.Status === 'complete') {
                app.connection.stop();
                this.showDownloadFile = true;
                this.fileSessionId =this.process.ProcessedOutput;
            } else if(this.process.Status === 'error') {
                app.connection.stop();
                this.isProcessInError = true;
            }
        });
    }

    async downloadFile(){
        try {
            let response = await axios({
                method: 'get',
                url: General.GetApiUrl("/api/document/DownloadDocumentGenericByIdSession?idSession=" + this.fileSessionId),
                withCredentials: true,
                responseType: 'blob'
            });
            saveAs(new Blob([response.data]), General.getFileNameFromHeader(response.headers));
        } catch (error) {
            General.showAlertDanger(i18n.t("GENERIC.DOWNLOAD_FILE_ERROR") as string, this);                          
        }
    }

    forceCancel(process: any) {
        axios({
            method: 'post',
            url: General.GetApiUrl('/api/Process/ForceEndTask?user=' + this.$store.state.user.Username + '&processId=' + process.ProcessId),
            withCredentials: true,
            responseType: 'json'
        });
    }

    formatDate(date){
        if (date == null) 
            return '';
        return General.showDate( date);
    }
}
